import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux"
import { BUS_BODY_WORK_PATH } from "../../../../config/paths";
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from "../../../layout/Content";
import BusBodyworkForm from "./BusBodyworkForm";
import { postBusBodyWork } from '../../../../actions/bus/BusBodyWork';

export const NewBusBodywork = ({ breadcrumbs, dispatchPostBusBodywork }) => {
  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };

    dispatchPostBusBodywork(newFormValues);
  };

  const content = (
    <BusBodyworkForm
      onSubmit={onSubmit}
      initialValues={{}}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Chasís"
      subtitle="Crear nuevo chasís"
      content={content}
    />
  );
};

NewBusBodywork.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostBusBodywork: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostBusBodywork: postBusBodyWork,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Carrocería',
      href: BUS_BODY_WORK_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(mapStateToProps, mapDispatchToProps)(NewBusBodywork)